import "../shared/IntakeForm.scss";

import Button from "components/Button/Button";
import { useNavigate } from "react-router-dom";
import { useIntakeToken, useToken } from "utils/context";

import { useAuth0 } from "@auth0/auth0-react";

import { useOrganizationSlug } from "../hooks/useOrganizationSlug";

type IntakeHeaderProps = {
  isUploading?: boolean;
  uploadingCount?: number;
};

export const IntakeHeader = ({
  isUploading = false,
  uploadingCount = 0,
}: IntakeHeaderProps) => {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const { intakeToken, setIntakeToken, setIntakeUser } = useIntakeToken();
  const { accessToken } = useToken();
  const organizationSlug = useOrganizationSlug();

  const isAuthenticated = !!intakeToken || !!accessToken;

  const handleLogout = () => {
    // warn if files are uploading
    if (isUploading) {
      const confirmed = window.confirm(
        `${uploadingCount} file${uploadingCount !== 1 ? "s are" : " is"} still uploading. Logging out will cancel the upload${uploadingCount !== 1 ? "s" : ""}.\n\nAre you sure you want to logout?`,
      );
      if (!confirmed) {
        return;
      }
    }

    if (accessToken) {
      // oauth user logout
      sessionStorage.removeItem("kaboodle.loginAnalyticsRecorded");
      localStorage.removeItem("kaboodle.loginAnalyticsRecordedRecently");
      localStorage.removeItem("kaboodle.loginAnalyticsLock");
      logout({
        logoutParams: { returnTo: `${window.location.origin}` },
      });
    } else if (intakeToken) {
      // intake user logout
      setIntakeToken(null);
      setIntakeUser(null);
      window.location.href = `/intake/${organizationSlug || "allan-koba"}/auth/login`;
    }
  };

  return (
    <header className="intake-header">
      <div
        className="header-logo"
        onClick={() =>
          organizationSlug && navigate(`/intake/${organizationSlug}/dashboard`)
        }
      >
        <div className="header-image">
          <img src="/static/images/logo-purple.png"></img>
        </div>
      </div>
      <div className="header-actions">
        {isAuthenticated && <Button onClick={handleLogout}>Logout</Button>}
      </div>
    </header>
  );
};

export default IntakeHeader;
